import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=ff3bfcd6&scoped=true"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"
import style0 from "./TextArea.vue?vue&type=style&index=0&id=ff3bfcd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3bfcd6",
  null
  
)

export default component.exports